module.exports = __webpack_public_path__ + "dist/img/explain1.b11678cc.png";